import { truncateName } from '../lib/playerId';
import type { GameSummary } from './GameScreen';

interface Props {
  playerId: string;
  summary: GameSummary;
  onPlayAgain: () => void;
}

export default function GameOverScreen({ playerId, summary, onPlayAgain }: Props) {
  const { iWon, reason, finalScores, myName, oppName } = summary;
  const tone = iWon ? 'win' : 'loss';

  return (
    <main className="screen screen--center">
      <div className={`accent-bar accent-bar--${tone}`} />

      <section className={`banner banner--${tone}`}>
        <h1 className="banner__title">{iWon ? '🏆  YOU WIN!' : '💀  YOU LOSE'}</h1>
        {reason === 'OPPONENT_ABANDONED' && (
          <p className="banner__reason">
            {iWon ? 'Opponent failed to reconnect in time.' : 'You failed to reconnect in time.'}
          </p>
        )}
      </section>

      <section className="panel final-score">
        <span className="panel__label">FINAL SCORE</span>
        <div className="final-score__row">
          <div className="final-score__side">
            <span className="final-score__value final-score__value--you">{finalScores.you}</span>
            <span className="final-score__name final-score__name--you">
              {truncateName(myName)}
            </span>
          </div>
          <span className="final-score__separator">—</span>
          <div className="final-score__side">
            <span className="final-score__value final-score__value--opp">
              {finalScores.opponent}
            </span>
            <span className="final-score__name final-score__name--opp">
              {truncateName(oppName)}
            </span>
          </div>
        </div>
      </section>

      <button type="button" className="btn btn--play-again" onClick={onPlayAgain}>
        PLAY AGAIN
      </button>

      <footer className="footnote">
        <p className="footnote__id">Player ID: {playerId}</p>
        <p>Reopen this page to reconnect with the same ID</p>
      </footer>
    </main>
  );
}
